import React from 'react';
import { useSelector } from 'react-redux';
import StickyNode from 'react-stickynode';

const Sticky = props => {
  const orientation = useSelector(({ app }) => app.orientation);
  const extensibleProps = { ...props };

  if (orientation === 'landscape') {
    extensibleProps.enabled = false;
  }

  return <StickyNode {...extensibleProps} />;
};

export default React.memo(Sticky);
